<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card class="p-5 mb-5">
      <div class="mt-5">
        <vs-radio
          v-model="search.Type"
          vs-name="radios1"
          vs-value="Admission"
          @input="initData()"
          >{{$t('AdmissionTests')}}</vs-radio
        >
        <vs-radio
          v-model="search.Type"
          vs-name="radios1"
          class="ml-10"
          vs-value="CourseClass"
          @input="initData()"
        >
          {{$t('CourseClassTests')}}</vs-radio
        >
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 w-full">
          <datepicker
            :format="format"
            :placeholder="$t('StartDate')"
            v-model="search.StartDate"
            input-class="mt-5 w-full"
            name="startDate"
            @input="searchCourseRegistration"
          ></datepicker>
        </div>

        <div class="vx-col lg:w-1/5 w-full">
          <datepicker
            :format="format"
            :placeholder="$t('EndDate')"
            v-model="search.EndDate"
            class="mt-5 w-full"
            name="endDate"
            @input="searchCourseRegistration"
          ></datepicker>
        </div>

        <div class="vx-col lg:w-1/3 w-full" v-if="search.Type == 'CourseClass'">
          <p>{{$t('CourseClass')}}</p>
          <v-select
            label="DisplayName"
            v-model="search.CourseClassID"
            :options="courseClass"
            :reduce="(CourseClass) => CourseClass.ID"
          />
        </div>

        <div class="vx-col lg:w-2/5 w-full" v-if="search.Type == 'Admission'">
          <!-- <p>course</p>
          <v-select
            label="Name"
            v-model="search.CourseID"
            :options="courses"
            :reduce="Course => Course.ID"
            @input="GetAdmissionTest()"
          /> -->
          <p>{{$t('CourseRegistration')}}</p>
          <v-select
            label="NameWithDate"
            v-model="search.CourseRegistrationID"
            :options="courseRegistrations"
            :reduce="(Course) => Course.AnnualPlanID"
            @input="getTraineesAdmissionTestForCourseRegistration()"
          />
        </div>

        <vs-button
          style="height: 45px"
          class="ml-6 mt-5"
          @click="loadTrainee"
          :disabled="!search.CourseClassID && !search.CourseRegistrationID"
          >{{$t('LoadTrainee')}}</vs-button
        >
      </div>
    </vx-card>
    <vx-card class="p-5" v-if="trainees.length > 0">
      <vs-table
        ref="table"
        class="mr-5 ml-5"
        pagination
        :max-items="10"
        :data="trainees"
      >
        <template slot="thead">
          <vs-th sort-key="Trainee">{{$t('Trainee')}}</vs-th>
          <vs-th sort-key="Attended" v-if="search.Type == 'Admission'"
            >{{$t('ShowExamWithAnswer')}}</vs-th
          >
          <vs-th sort-key="Attended" v-if="search.Type == 'CourseClass'"
            >{{$t('Exams')}}</vs-th>
              <vs-th sort-key="Attended" v-if="search.Type == 'Admission'">{{$t('Print')}}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.FullName }}
                </p>
              </vs-td>
              <vs-td v-if="search.Type == 'CourseClass'">
                <router-link
                  :to="{
                    name: 'TraineeExam',
                    params: { ID: tr.ID, CourseClassID: search.CourseClassID },
                  }"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                >
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                /></router-link>
              </vs-td>
              <vs-td v-if="search.Type == 'Admission'">
                <vx-tooltip
                  :text="$t('ShowExamWithAnswer')"
                  position="left"
                  delay=".3s"
                >
                  <router-link
                    :to="{
                      name: 'TraineeExamWithAnswer',
                      params: {
                        ExamID: tr.CourseClassExamID,
                        TraineeID: tr.ID,
                        CourseClassID: 0,
                      },
                    }"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  >
                    <feather-icon
                      icon="PlayIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  /></router-link>
                </vx-tooltip>
              </vs-td>
               <vs-td v-if="search.Type == 'Admission'">
                  <vx-tooltip :text="$t('PrintExamAnswer')" position="left" delay=".3s">
                      <feather-icon @click.stop="PrintExamAnser(tr)" icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  />
                  </vx-tooltip>
               </vs-td>

            </vs-tr>
          </tbody>
        </template>
      </vs-table>

    </vx-card>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import vSelect from "vue-select";
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleCourseClassExam from "@/store/courseClassExam/moduleCourseClassExam.js";
import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";

export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      format: "dd-MM-yyyy",
      search: {},
    };
  },
  computed: {
    courseClassExams() {
      return this.$store.state.courseClassExamList.courseClassExams;
    },
    courseClass() {
      return this.$store.state.courseClassList.courseClass;
    },
    courses() {
      return this.$store.state.courseList.courses;
    },
    trainees() {
      debugger;
      return this.$store.state.traineeList.trainees;
    },
    courseRegistrations() {
      return this.$store.state.courseRegistrationList.courseRegistrations;
    },
  },
  methods: {
     PrintExamAnser(tr)
      {
         window.open('#/Report/CourseExamAnswer/'+tr.CourseClassExamID+'/'+tr.ID, '_blank');
      },
    initData() {
      this.$store.commit("traineeList/SET_Trainees", []);
    },
    searchCourseRegistration() {

      if(this.search.Type == 'CourseClass')
      {
           this.search.CourseClassID = null;
             this.$store.dispatch("courseClassList/SearchCourseClass",this.search);
      }
      else
      {
      this.search.CourseID = null;
      var vm = this;
      this.$vs.loading();
      this.$store
        .dispatch(
          "courseRegistrationList/searchMainCourseRegistration",
          this.search
        )
        .then(() => {
          this.$vs.loading.close();
          vm.$refs.table.currentx =
            vm.$store.state.courseRegistrationList.search.pageNum;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
      }
    },

    GetAdmissionTest() {
      this.search.ExamTypeID = 7; // admission test
      this.$vs.loading();
      this.$store
        .dispatch("courseClassExamList/searchCourseClassExam", this.search)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
        });
    },
    GetCourses() {
      debugger;
      this.$vs.loading();
      this.$store
        .dispatch("courseList/fetchDataListItemsByFilter", {})
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
        });
    },
    initValues() {
      this.search.CourseClassID = "";

      this.$store.state.traineeList.trainees = [];
    },
    // submitData()
    // {
    //     var vm=this;
    //     var trainees=this.$store.state.traineeAttendanceList.traineeAttendance.map(function(val){
    //          val.TraineeID=val.Trainee.ID;
    //          val.Trainee=null;
    //         val.CourseClassSessionID= vm.search.SessionID;
    //         return val;
    //     });
    //      this.$store.dispatch("traineeAttendanceList/SaveTraineeAttendance",
    //     trainees
    //      ).then(()=>{
    //            this.initValues();
    //      });
    // },
    loadTrainee() {
      if (this.search.Type == "Admission") {
        debugger;
        this.$vs.loading();
        this.$store
          .dispatch(
            "traineeList/getTraineesAdmissionTestForCourseRegistration",
            this.search.CourseRegistrationID
          )
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      } else {
        this.$store.dispatch(
          "traineeList/GetTraineeByCourseClassID",
          this.search.CourseClassID
        );
        this.$store.state.courseClassList.search.AdminCourseClassID =
          this.search.CourseClassID;
      }
    },
    formatJsDate(dateToFormat) {
      return (
        dateToFormat.getFullYear() +
        "-" +
        (dateToFormat.getMonth() + 1) +
        "-" +
        dateToFormat.getDate()
      );
    },
  },
  created() {
    if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule(
        "courseRegistrationList",
        moduleCourseRegistration
      );
      moduleCourseRegistration.isRegistered = true;
    }
    this.search.StartDate = new Date().getFullYear() + "/01/01";
    this.search.EndDate = new Date().getFullYear() + "/12/31";
    this.search.CourseID = this.$store.state.courseRegistrationList.CourseID;
    this.searchCourseRegistration();
    if (!moduleCourseClassExam.isRegistered) {
      this.$store.registerModule("courseClassExamList", moduleCourseClassExam);
      moduleCourseClassExam.isRegistered = true;
    }
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    this.GetCourses();

    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }

    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }

    this.$store.dispatch("courseClassList/getCourseClassForDisplayName");

    if (this.$store.state.courseClassList.search.AdminCourseClassID)
      this.search.CourseClassID =
        this.$store.state.courseClassList.search.AdminCourseClassID;

    this.$store.commit("traineeList/SET_Trainees", []);
  },
};
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
.vdp-datepicker__calendar {
  z-index: 429 !important;
}
</style>
